export { default as MDXRenderer } from "./MDXRenderer";
